import { Parent } from "./parent"

const baseShowTooltip = true
const baseBgColor = "rgba(0,0,0,.4)"
const baseExtraCssText = "border-radius: 10px;"
const baseAxisPointer = {
  type: "shadow"
}
const baseTextStyle = {
  color: "rgba(255,255,255,1)",
  fontWeight: 400,

  fontSize: 14
}
export class Tooltip extends Parent {
  constructor(trigger, options) {
    super()
    this.trigger = trigger
    this.show = this.hasVal(options, "show") ? false : baseShowTooltip
    this.backgroundColor = this.hasVal(options, "backgroundColor") ? options.backgroundColor : baseBgColor
    this.extraCssText = this.hasVal(options, "extraCssText") ? options.extraCssText : baseExtraCssText
    this.textStyle = this.hasVal(options, "textStyle") ? options.textStyle : baseTextStyle
    this.axisPointer = this.hasVal(options, "axisPointer") ? options.axisPointer : baseAxisPointer
    this.borderWidth = this.hasVal(options, "borderWidth") ? options.borderWidth : 0
    this.showContent = this.hasVal(options, "showContent") ? options.showContent : true //显示提示框浮层
    this.extraCssText = this.hasVal(options, "extraCssText") ? options.extraCssText : null //额外附加到浮层的 css 样式
    this.checkArgs(arguments)
  }
  checkArgs(args) {
    const argNameArr = Tooltip.toString()
      .match(/\((.+?)\)/g)[0]
      .slice(1, -1)
      .replace(/\s+/g, "")
      .split(",")
    for (let i = 0; i < argNameArr.length; i++) {
      if (typeof args[i] === "undefined") {
        throw new Error(
          "the argument '" + argNameArr[i] + "' from class tooltip is undefined,please check this argument"
        )
      }
    }
  }
}
